export function canAccessResource(auth, resource, method) {
  return true;
  /* let hasAccess = false;
  if (resource.audiences && !resource.audiences.includes(auth.currentUser.aud))
    return false;
  if (!auth.currentUser.scope) return true; // to make it work with current version

  const scopes = auth.currentUser.scope
    .split(' ')
    .filter((scope) => scope !== null);

  const methodsAndPaths = scopes.map((scope) => {
    const [methods, path] = scope.split('#');
    return [methods.split('/'), path];
  });

  const permissionsForAll = methodsAndPaths.filter(
    (item) => item[1] === '_ALL_',
  )?.[0];

  if (
    permissionsForAll?.[0] &&
    (!method || permissionsForAll[0].includes(method))
  ) {
    hasAccess = true;
  }

  const permissionsForPath = methodsAndPaths.filter(
    (item) => item[1] === resource.name,
  )?.[0];

  if (permissionsForPath) {
    if (permissionsForPath.includes(method)) {
      hasAccess = true;
    } else {
      hasAccess = false;
    }
  }

  if (!hasAccess) {
    console.error(`Forbidden resource: ${method} ${resource.name}`, { scopes });
  }
  return hasAccess; */
}

export const RequestMethodType = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
  PATCH: 'PATCH',
};
